import { FormControlLabel, Switch } from '@mui/material';
import { ControlFieldProps } from '@src/assets/types';
import { useController } from 'react-hook-form';

function ControlFieldElement({
    id,
    name,
    label,
    control,
    isDisabled = false,
    checkedField,
    sxCustom = {},
    sxTheme,
    onChange,
    ...rest
}: ControlFieldProps) {
    const { field } = useController({
        name,
        control,
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        field.onChange(event); // Chiamata al metodo onChange di react-hook-form
        if (onChange) {
            onChange(event, checked); // Chiamata all'onChange personalizzato, se definito
        }
    };

    return (
        <FormControlLabel
            id={id}
            label={label}
            control={
                <Switch
                    checked={checkedField || field.value}
                    value={checkedField || field.value}
                    disabled={isDisabled}
                    name={name}
                    inputRef={field.ref} // send input ref, so we can focus on input when error appear
                    onChange={handleChange}
                    sx={[
                        theme => ({
                            margin: `${theme.spacing(1)} 0`,
                            ...(sxTheme && sxTheme(theme)),
                        }),
                        sxCustom,
                    ]}
                />
            }
            sx={{ margin: 0 }}
            {...rest}
        />
    );
}

export default ControlFieldElement;
